import { createContext, useContext, useEffect, useState } from 'react';
import { Manager } from 'socket.io-client';
import { useSession } from 'next-auth/react';

const SocketContext = createContext();

export const SocketProvider = ({ children }) => {
  const { data: session, status } = useSession();

  const [socket, setSocket] = useState(null);
  const [auctionSocket, setAuctionSocket] = useState(null);

  const [socketConnected, setSocketConnected] = useState(false);
  const [auctionSocketConnected, setAuctionSocketConnected] = useState(false);
  const [onlineUsers, setOnlineUsers] = useState(null);

  useEffect(() => {
    const socketManager = new Manager();
    const newAuctionSocket = socketManager.socket('/auctions');

    const handleAuctionConnect = () => {
      console.log('Connecting to Auction Socket.IO server.');
      setAuctionSocketConnected(true);
    };

    const handleAuctionDisconnect = () => {
      console.log('Disconnected from Auction Socket.IO server.');
      setAuctionSocketConnected(false);
    };

    newAuctionSocket.on('connect', handleAuctionConnect);
    newAuctionSocket.on('disconnect', handleAuctionDisconnect);

    setAuctionSocket(newAuctionSocket);

    return () => {
      newAuctionSocket.off('connect', handleAuctionConnect);
      newAuctionSocket.off('disconnect', handleAuctionDisconnect);
      newAuctionSocket.close();
    };
  }, []);

  useEffect(() => {
    if (!session || status !== 'authenticated') return;

    const socketManager = new Manager({
      query: {
        username: session.user.token.username,
      }
    });

    const messagingSocket = socketManager.socket('/messaging');

    const handleConnect = () => {
      console.log('Connecting to Socket.IO server.');
      setSocketConnected(true);
    };

    const handleDisconnect = () => {
      console.log('Disconnected from Socket.IO server.');
      setSocketConnected(false);
    };

    const handleGetUsers = (users) => {
      const filteredOnlineUsers = users.filter(user => user !== session.user.token.username);
      setOnlineUsers(filteredOnlineUsers);
    };

    messagingSocket.on('connect', handleConnect);
    messagingSocket.on('disconnect', handleDisconnect);
    messagingSocket.on('getUsers', handleGetUsers);

    setSocket(messagingSocket);

    return () => {
      messagingSocket.off('connect', handleConnect);
      messagingSocket.off('disconnect', handleDisconnect);
      messagingSocket.off('getUsers', handleGetUsers);
      messagingSocket.close();
    };
  }, [session, status]);

  return (
    <SocketContext.Provider value={{ socket, socketConnected, onlineUsers, auctionSocket, auctionSocketConnected }}>
      {children}
    </SocketContext.Provider>
  );
};

export const useSocket = () => {
  return useContext(SocketContext);
};
